import hctTable from './components/hct-table/hct-table.vue';
import hctSetting from './components/hct-setting/hct-setting.vue'
import hctLogistics from './components/hct-logistics/hct-logistics.vue'
import hctMessage from './components/hct-message/hct-message.vue'
import hctPopover from './components/hct-popover/hct-popover.vue'
import hctSearch from './components/hct-search/hct-search.vue'
// import svgIcon from "./components/SvgIcon/index.vue"

const components = [hctTable,hctSetting,hctLogistics,hctMessage,hctPopover]
 
const install = function(Vue, opts={}) {
    components.forEach(component => {
      Vue.component(component.name, component)
    })
}
 /**
 * 判断是否是直接引入文件,如果是,就不用调用Vue.use();
 */
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}
 
export default {
    install,
    ...components
}